import {React, useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function LegalServiceCard () {

    useEffect(()=>{
        AOS.init({duration:1000});
      }, []);

    const serviceCard_1 =[
        {
            heading : "Legal Services",
            service1 : "Document Verification",
            service2 : "Acquisition Clearance",
            service3 : "Ground information Verification",
            service4 : "Revenue and Registration",
            service5 : "Deparment comparison",
            service6 : "Etc.",
        },
        {
            heading : "Property registration and sale deed",
            service1 : "Agreement Drafts",
            service2 : "Sale deed Drafts",
            service3 : "Sale deed agreements",
            service4 : "On-day Registration Service",
            service5 : "Sale deed collection",
            service6 : "MoD - Bank Settlements",
            service7 : "Will Registration",
            service8 : "Etc."
        },

 
    ]
    return(
    <>
        <div className="md:max-w-6xl mx-auto px-6 mb-10 sm:mb-20">

            <div className="flex flex-wrap justify-around">
                {
                    serviceCard_1.map((item) => {
                        return(
                            <div className="liaisonservice-card my-14 shadow-xl" data-aos="fade-up">
                            
                                <h2 className="legalservices-heading">{item.heading}</h2>
                        
                                <ul className="pl-4 my-5 font-[lato] text-[#363537] text-[18.846px] leading-[30.528px] tracking-[0.50px] " style={{ listStyle: 'disc' }} >
                                    <li>{item.service1}</li>
                                    <li>{item.service2}</li>
                                    <li>{item.service3}</li>   
                                    <li>{item.service4}</li>   
                                    <li>{item.service5}</li>
                                    <li>{item.service6}</li>   
                                    <li>{item.service7}</li>   
                                    <li>{item.service8}</li>   
                                </ul>
                            </div>
                        )
                    })
                }
            </div>

        </div>


    </>
    );
}

export default LegalServiceCard;